<template>
  <div id="app">
    <h1>Faiz Ahmad Faraz Auto Poem Generation</h1>
    <h3>Click on any of the starting word</h3>
    <div class="seedWords">
      <div v-for="word in seedwords" @click="setInput(word)">
        {{word}}
      </div>
    </div>
    <div class="result">
      {{inputText}}
    </div>
  </div>
</template>

<script>
let tf;
import Tokenizer from './tokenizer.js?v=5';
const indexWord = { '1': 'hai',
  '2': 'to',
  '3': 'haiñ',
  '4': 'ke',
  '5': 'na',
  '6': 'nahīñ',
  '7': 'vo',
  '8': 'bhī',
  '9': 'meñ',
  '10': 'se',
  '11': 'ham',
  '12': 'dil',
  '13': 'kī',
  '14': 'kar',
  '15': 'jo',
  '16': 'the',
  '17': 'kyā',
  '18': 'ki',
  '19': 'aae',
  '20': 'karte',
  '21': 'yaad',
  '22': 'ko',
  '23': 'ye',
  '24': 'ik',
  '25': 'hī',
  '26': 'aa',
  '27': 'raheñge',
  '28': 'chale',
  '29': 'aur',
  '30': 'terī',
  '31': 'magar',
  '32': 'jab',
  '33': 'thā',
  '34': 'baat',
  '35': 'jis',
  '36': 'kā',
  '37': 'gaī',
  '38': 'raat',
  '39': 'dard',
  '40': 'raah',
  '41': 'pe',
  '42': 'ho',
  '43': 'un',
  '44': 'har',
  '45': 'kisī',
  '46': 'ne',
  '47': 'liyā',
  '48': 'phir',
  '49': 'aarzū',
  '50': 'gae',
  '51': 'sahar',
  '52': 'kuchh',
  '53': 'ab',
  '54': 'ġham',
  '55': 'baazī',
  '56': 'rahā',
  '57': 'lagā',
  '58': 'ghaḍī',
  '59': 'sivā',
  '60': 'paivand',
  '61': 'lage',
  '62': 'jaate',
  '63': 'jaane',
  '64': 'kis',
  '65': 'liye',
  '66': 'ummīdvār',
  '67': 'baithā',
  '68': 'huuñ',
  '69': 'aisī',
  '70': 'guzrī',
  '71': 'sahī',
  '72': 'mayassar',
  '73': 'rahguzar',
  '74': 'parvarishelauhoqalam',
  '75': 'guzartī',
  '76': 'raqam',
  '77': 'rahī',
  '78': 'shaam',
  '79': 'bhar',
  '80': 'rañg',
  '81': 'rahe',
  '82': 'mohabbat',
  '83': 'koī',
  '84': 'yuuñ',
  '85': 'āeñge',
  '86': 'guzār',
  '87': 'duniyā',
  '88': 'gar',
  '89': 'tum',
  '90': 'so',
  '91': 'kab',
  '92': 'hogī',
  '93': 'sunte',
  '94': 'lagte',
  '95': 'tere',
  '96': 'judā',
  '97': 'aap',
  '98': 'uth',
  '99': 'tirī',
  '100': 'bazm',
  '101': 'zindagī',
  '102': 'jaae',
  '103': 'hue',
  '104': 'kyuuñ',
  '105': 'dete',
  '106': 'daaġh',
  '107': 'mahak',
  '108': 'machal',
  '109': 'muflis',
  '110': 'badal',
  '111': 'qabā',
  '112': 'bahāne',
  '113': 'tumheñ',
  '114': 'karne',
  '115': 'behisāb',
  '116': 'saare',
  '117': 'fasāne',
  '118': 'dekhne',
  '119': 'zikr',
  '120': 'zamāne',
  '121': 'baaqī',
  '122': 'bahut',
  '123': 'nāgavār',
  '124': 'dukh',
  '125': 'nigāh',
  '126': 'manzil',
  '127': 'justujū',
  '128': 'nāumīd',
  '129': 'aatī',
  '130': 'visāl',
  '131': 'rāhateñ',
  '132': 'dekh',
  '133': 'chāñdnī',
  '134': 'dukhātī',
  '135': 'guloñ',
  '136': 'ġhamejahāñ',
  '137': 'aate',
  '138': 'hoñge',
  '139': 'shabefirāq',
  '140': 'bhare',
  '141': 'kah',
  '142': 'dī',
  '143': 'bādenaubahār',
  '144': 'maqām',
  '145': '\'faiz\'',
  '146': 'jachā',
  '147': 'kūeyār',
  '148': 'donoñ',
  '149': 'sūedār',
  '150': 'jāntā',
  '151': 'aao',
  '152': 'jahān',
  '153': 'masrūfeintizār',
  '154': 'gulshan',
  '155': 'begāna',
  '156': 'diyā',
  '157': 'tujh',
  '158': 'dilfareb',
  '159': 'rozgār',
  '160': 'kārobār',
  '161': 'nākām',
  '162': 'ishq',
  '163': 'chāho',
  '164': 'do',
  '165': 'dar',
  '166': 'kaisā',
  '167': 'jiit',
  '168': 'jaise',
  '169': 'kahnā',
  '170': 'haare',
  '171': 'maat',
  '172': 'hamesha',
  '173': 'thahregā',
  '174': 'ai',
  '175': 'basar',
  '176': 'haar',
  '177': 'mehrbān',
  '178': 'bhūle',
  '179': 'fursategunāh',
  '180': 'milī',
  '181': 'chaar',
  '182': 'din',
  '183': 'dekhe',
  '184': 'hausle',
  '185': 'parvardigār',
  '186': 'goyā',
  '187': 'qauloqarār',
  '188': 'pahle',
  '189': 'apne',
  '190': 'kabhī',
  '191': 'sahāre',
  '192': 'baḍī',
  '193': 'chiiz',
  '194': 'hamdam',
  '195': 'visāleyār',
  '196': 'faqat',
  '197': 'gul',
  '198': 'khile',
  '199': 'mile',
  '200': 'mai',
  '201': 'pī',
  '202': 'ajiib',
  '203': 'āshnā',
  '204': 'bahār',
  '205': 'vasl',
  '206': 'tarzetaġhāful',
  '207': 'jā',
  '208': 'saarī',
  '209': 'duur',
  '210': 'mubārak',
  '211': 'arzetamannā',
  '212': 'zarā',
  '213': 'paas',
  '214': 'baithe',
  '215': 'bedam',
  '216': 'hisāb',
  '217': 'bīmār',
  '218': 'davā',
  '219': 'shabeġham',
  '220': 'lambī',
  '221': 'achchhe',
  '222': 'masīhā',
  '223': 'shifā',
  '224': 'abr',
  '225': 'sharāb',
  '226': 'is',
  '227': 'baad',
  '228': 'azaab',
  '229': 'tumhārī',
  '230': 'ujālā',
  '231': 'shabgazīda',
  '232': 'intizār',
  '233': 'tujhe',
  '234': 'subh',
  '235': 'aaj',
  '236': 'uthī',
  '237': 'tirā',
  '238': 'jagā',
  '239': 'zaḳhm',
  '240': 'bharne',
  '241': 'moāmla',
  '242': 'saaf',
  '243': 'kahne',
  '244': 'sāmne',
  '245': 'aatā',
  '246': 'apnā',
  '247': 'iḳhtiyār',
  '248': 'chāhe',
  '249': 'jahāñ',
  '250': 'chaleñ',
  '251': 'rahbar',
  '252': 'apnī',
  '253': 'rāhat',
  '254': 'chuke',
  '255': 'shaiḳh',
  '256': 'leader',
  '257': 'musāhib',
  '258': 'sahāfī',
  '259': 'ḳhud',
  '260': 'hidāyat',
  '261': 'kareñge',
  '262': 'merī',
  '263': 'ḳhāmoshiyoñ',
  '264': 'larzāñ',
  '265': 'mere',
  '266': 'nāloñ',
  '267': 'gumshuda',
  '268': 'āvāz',
  '269': 'minnatechārasāz',
  '270': 'kaun',
  '271': 'kare',
  '272': 'jāñnavāz',
  '273': 'thiiñ',
  '274': 'qurbateñ',
  '275': 'kitnī',
  '276': 'baham',
  '277': 'paḍī',
  '278': 'judāiyāñ',
  '279': 'shāmefirāq',
  '280': 'pūchh',
  '281': 'aaī',
  '282': 'tal',
  '283': 'bahal',
  '284': 'gayā',
  '285': 'jaañ',
  '286': 'thī',
  '287': 'sambhal',
  '288': 'adāehusn',
  '289': 'maasūmiyat',
  '290': 'kam',
  '291': 'de',
  '292': 'gunāhgārenazar',
  '293': 'hijāb',
  '294': 'nikle' };

  const wordIndex = { hai: 1,
  to: 2,
  'haiñ': 3,
  ke: 4,
  na: 5,
  'nahīñ': 6,
  vo: 7,
  'bhī': 8,
  'meñ': 9,
  se: 10,
  ham: 11,
  dil: 12,
  'kī': 13,
  kar: 14,
  jo: 15,
  the: 16,
  'kyā': 17,
  ki: 18,
  aae: 19,
  karte: 20,
  yaad: 21,
  ko: 22,
  ye: 23,
  ik: 24,
  'hī': 25,
  aa: 26,
  'raheñge': 27,
  chale: 28,
  aur: 29,
  'terī': 30,
  magar: 31,
  jab: 32,
  'thā': 33,
  baat: 34,
  jis: 35,
  'kā': 36,
  'gaī': 37,
  raat: 38,
  dard: 39,
  raah: 40,
  pe: 41,
  ho: 42,
  un: 43,
  har: 44,
  'kisī': 45,
  ne: 46,
  'liyā': 47,
  phir: 48,
  'aarzū': 49,
  gae: 50,
  sahar: 51,
  kuchh: 52,
  ab: 53,
  'ġham': 54,
  'baazī': 55,
  'rahā': 56,
  'lagā': 57,
  'ghaḍī': 58,
  'sivā': 59,
  paivand: 60,
  lage: 61,
  jaate: 62,
  jaane: 63,
  kis: 64,
  liye: 65,
  'ummīdvār': 66,
  'baithā': 67,
  'huuñ': 68,
  'aisī': 69,
  'guzrī': 70,
  'sahī': 71,
  mayassar: 72,
  rahguzar: 73,
  parvarishelauhoqalam: 74,
  'guzartī': 75,
  raqam: 76,
  'rahī': 77,
  shaam: 78,
  bhar: 79,
  'rañg': 80,
  rahe: 81,
  mohabbat: 82,
  'koī': 83,
  'yuuñ': 84,
  'āeñge': 85,
  'guzār': 86,
  'duniyā': 87,
  gar: 88,
  tum: 89,
  so: 90,
  kab: 91,
  'hogī': 92,
  sunte: 93,
  lagte: 94,
  tere: 95,
  'judā': 96,
  aap: 97,
  uth: 98,
  'tirī': 99,
  bazm: 100,
  'zindagī': 101,
  jaae: 102,
  hue: 103,
  'kyuuñ': 104,
  dete: 105,
  'daaġh': 106,
  mahak: 107,
  machal: 108,
  muflis: 109,
  badal: 110,
  'qabā': 111,
  'bahāne': 112,
  'tumheñ': 113,
  karne: 114,
  'behisāb': 115,
  saare: 116,
  'fasāne': 117,
  dekhne: 118,
  zikr: 119,
  'zamāne': 120,
  'baaqī': 121,
  bahut: 122,
  'nāgavār': 123,
  dukh: 124,
  'nigāh': 125,
  manzil: 126,
  'justujū': 127,
  'nāumīd': 128,
  'aatī': 129,
  'visāl': 130,
  'rāhateñ': 131,
  dekh: 132,
  'chāñdnī': 133,
  'dukhātī': 134,
  'guloñ': 135,
  'ġhamejahāñ': 136,
  aate: 137,
  'hoñge': 138,
  'shabefirāq': 139,
  bhare: 140,
  kah: 141,
  'dī': 142,
  'bādenaubahār': 143,
  'maqām': 144,
  '\'faiz\'': 145,
  'jachā': 146,
  'kūeyār': 147,
  'donoñ': 148,
  'sūedār': 149,
  'jāntā': 150,
  aao: 151,
  'jahān': 152,
  'masrūfeintizār': 153,
  gulshan: 154,
  'begāna': 155,
  'diyā': 156,
  tujh: 157,
  dilfareb: 158,
  'rozgār': 159,
  'kārobār': 160,
  'nākām': 161,
  ishq: 162,
  'chāho': 163,
  do: 164,
  dar: 165,
  'kaisā': 166,
  jiit: 167,
  jaise: 168,
  'kahnā': 169,
  haare: 170,
  maat: 171,
  hamesha: 172,
  'thahregā': 173,
  ai: 174,
  basar: 175,
  haar: 176,
  'mehrbān': 177,
  'bhūle': 178,
  'fursategunāh': 179,
  'milī': 180,
  chaar: 181,
  din: 182,
  dekhe: 183,
  hausle: 184,
  'parvardigār': 185,
  'goyā': 186,
  'qauloqarār': 187,
  pahle: 188,
  apne: 189,
  'kabhī': 190,
  'sahāre': 191,
  'baḍī': 192,
  chiiz: 193,
  hamdam: 194,
  'visāleyār': 195,
  faqat: 196,
  gul: 197,
  khile: 198,
  mile: 199,
  mai: 200,
  'pī': 201,
  ajiib: 202,
  'āshnā': 203,
  'bahār': 204,
  vasl: 205,
  'tarzetaġhāful': 206,
  'jā': 207,
  'saarī': 208,
  duur: 209,
  'mubārak': 210,
  'arzetamannā': 211,
  'zarā': 212,
  paas: 213,
  baithe: 214,
  bedam: 215,
  'hisāb': 216,
  'bīmār': 217,
  'davā': 218,
  'shabeġham': 219,
  'lambī': 220,
  achchhe: 221,
  'masīhā': 222,
  'shifā': 223,
  abr: 224,
  'sharāb': 225,
  is: 226,
  baad: 227,
  azaab: 228,
  'tumhārī': 229,
  'ujālā': 230,
  'shabgazīda': 231,
  'intizār': 232,
  tujhe: 233,
  subh: 234,
  aaj: 235,
  'uthī': 236,
  'tirā': 237,
  'jagā': 238,
  'zaḳhm': 239,
  bharne: 240,
  'moāmla': 241,
  saaf: 242,
  kahne: 243,
  'sāmne': 244,
  'aatā': 245,
  'apnā': 246,
  'iḳhtiyār': 247,
  'chāhe': 248,
  'jahāñ': 249,
  'chaleñ': 250,
  rahbar: 251,
  'apnī': 252,
  'rāhat': 253,
  chuke: 254,
  'shaiḳh': 255,
  leader: 256,
  'musāhib': 257,
  'sahāfī': 258,
  'ḳhud': 259,
  'hidāyat': 260,
  'kareñge': 261,
  'merī': 262,
  'ḳhāmoshiyoñ': 263,
  'larzāñ': 264,
  mere: 265,
  'nāloñ': 266,
  gumshuda: 267,
  'āvāz': 268,
  'minnatechārasāz': 269,
  kaun: 270,
  kare: 271,
  'jāñnavāz': 272,
  'thiiñ': 273,
  'qurbateñ': 274,
  'kitnī': 275,
  baham: 276,
  'paḍī': 277,
  'judāiyāñ': 278,
  'shāmefirāq': 279,
  'pūchh': 280,
  'aaī': 281,
  tal: 282,
  bahal: 283,
  'gayā': 284,
  'jaañ': 285,
  'thī': 286,
  sambhal: 287,
  'adāehusn': 288,
  'maasūmiyat': 289,
  kam: 290,
  de: 291,
  'gunāhgārenazar': 292,
  'hijāb': 293,
  nikle: 294 };

 const maxTokenLength = 12;
 const tokenizer = new Tokenizer();
 tokenizer.indexWord = indexWord;
 tokenizer.wordIndex = wordIndex;
 const vocabSize = 294;

 function generateSeedWord()  {
  return tokenizer.indexWord[Math.floor(Math.random()*vocabSize+1)];
 }



 function pad_array_left(arr,len,fill) {   return Array(len).fill(fill).concat(arr).slice( arr.length); }
export default {
  name: 'App',
  data:()=>({
    loadedModel:null,
    inputText:'',
    seedwords:null
  }),
  created(){
    this.seedwords = [];
    for(let i=0;i<4;i++){
      this.seedwords.push(generateSeedWord());
    }
  },
  mounted(){
      tf = window.tf;
      this.loadModel()
  },
  methods:{
    async loadModel(){
      this.loadedModel = await tf.loadLayersModel('/word-prediction-frontend/model.json')
      console.log('model loaded')
    },
    async predict(){
      if(!this.inputText){
        return;
      }
      var tokenList1 = tokenizer.textsToSequences([this.inputText]);
      tokenList1 = [pad_array_left(tokenList1[0], maxTokenLength - 1, 0)]
     //console.log(tokenList1);
      var prediction = this.loadedModel.predict(tf.tensor(tokenList1));
      prediction = prediction.reshape([vocabSize]);
      var { values, indices } = tf.topk(prediction, 3);
      values.print()
      indices.print()
      indices = await indices.array();
      this.inputText += ` ${indexWord[indices[0]]}`;
      //console.log(indices);
      //console.log(indexWord[indices[0]],indexWord[indices[1]],indexWord[indices[2]])
    },
    setInput(word){
      this.inputText = word;
      let i=0;
      const predictionInterval = setInterval(()=>{
        i++;
        if(i < 50){
          this.predict();
        }
        else{
          clearInterval(predictionInterval)
        }
       },500);
    }

  }
}
</script>

<style>
  @import './style.css';
</style>
